export const getTags= state => state.tags.tags;
export const tagsStatus = state => state.tags.status;
export const tagsError = state => state.tags.error;